import React, { useEffect, useState } from 'react';
import { Footer } from '../../../components/SwapKiwi/Footer';
// import { SKHeader } from '../../../components/SwapKiwi/Header';
import {
  clearSelectedNFTs,
  AppState,
  storeAppState,
  //setWalletDropdownOpen,
  //setRedirectRouteAfterLoginSuccess,
} from '../../../ducks/app/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAppState,
  //selectRedirectRouteAfterLoginSuccess,
  //selectWalletDropdownOpen,
} from '../../../ducks/app/selectors';
import { useWeb3React } from '@web3-react/core';
import { useHistory, useLocation } from 'react-router-dom';
import { checkPendingTransactions } from '../../../ducks/transactions/actions';
import classNames from 'classnames';
import { SKTabs } from '../../../components/SwapKiwi/Tabs';
import { ButtonSizes, SKButton } from '../../../components/SwapKiwi/Button';
import { tabs } from '../../../config/tabs';
import { ReactComponent as ReloadIcon } from '../../../assets/svg/icons/reload.svg';
import { Routes, publicRoutes } from '../../../constants/routes';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
export const Layout: React.FC<{ className?: string }> = ({ className, children }) => {
  const appState = useSelector(selectAppState);
  const dispatch = useDispatch();
  const { account, library } = useWeb3React();
  const handleStartSwapButton = (): void => {
    if (appState === AppState.CREATING_SWAP) {
      dispatch(storeAppState(AppState.DEFAULT));
      dispatch(clearSelectedNFTs());
    } else {
      dispatch(storeAppState(AppState.CREATING_SWAP));
    }
    history.push(Routes.CREATE_SWAP);
  };
  useEffect(() => {
    if (account) dispatch(checkPendingTransactions(library));
  }, [account]);
  const history = useHistory();
  const location = useLocation();
  const [pathName, setPathName] = useState(location.pathname);
  const [isPublicRoute, setIsPublicRoute] = useState(publicRoutes.includes(location.pathname));
  const swapInProgress = localStorage.getItem('swapInProgress');
  const isBiggerThanMobile = useBreakpoint('48em');
  useEffect(() => {
    setPathName(location.pathname);
    setIsPublicRoute(publicRoutes.includes(location.pathname));
  }, [location.pathname]);

  return (
    <div
      className={classNames('flex flex-col min-h-screen xs-only:max-w-viewport xs-only:overflow-x-hidden', className)}
    >
      {/* <SKHeader onWalletClick={showWalletsModal} onLogoutClick={onLogoutClick} />
      <WalletsModal
        walletDropdownOpen={walletDropdownOpen}
        onClose={(): void => {
          dispatch(setWalletDropdownOpen(false));
          dispatch(setRedirectRouteAfterLoginSuccess(Routes.YOUR_NFTS));
        }}
        onLoginSuccess={hideWalletsModal}
      /> */}
      <main>
        {!isPublicRoute && (
          <nav className="app-container mx-auto flex justify-between items-center h-5 md-and-below:pr-1">
            <SKTabs tabs={tabs} className="mt-auto border-t-0" />
            {!pathName.includes(Routes.CREATE_SWAP) && !pathName.includes('/resolve-swap') && (
              <SKButton
                size={isBiggerThanMobile ? ButtonSizes.XL : ButtonSizes.SM}
                color={swapInProgress ? 'tertiary' : 'primary'}
                iconRight={isBiggerThanMobile ? ReloadIcon : undefined}
                className="stroke-current text-cloud-900"
                onClick={handleStartSwapButton}
              >
                {swapInProgress ? 'Continue Swap' : 'Create Swap'}
              </SKButton>
            )}
          </nav>
        )}
        {children}
      </main>
      <Footer theme="cloud" type="onlySocials" />
    </div>
  );
};
